/** The amount a subtotal still needs to reach a store's order minimum; 0 when met or when the store has none. */
export function orderMinimumShortfall(subtotal: number | string, minimum: number): number {
  const amount = Number.parseFloat(String(subtotal)) || 0
  return minimum > 0 ? Math.max(0, Number((minimum - amount).toFixed(2))) : 0
}
